import http from '../http'
import * as types from '../mutation-types';

export const state = {
    status: '',
    projects: null,
};

export const getters = {
    loadStatus: state => state.status,
    projects: state => state.projects
};

export const mutations = {
    /** LOAD */
    [types.LOAD_PROJECTS_LOADING](state) {
        state.status = 'loading'
    },
    [types.LOAD_PROJECTS_SUCCESS](state, {data, meta}) {
        state.status = 'success'
        state.projects = data
    },
    [types.LOAD_PROJECTS_ERROR](state) {
        state.status = 'error'
    }
};

export const actions = {
    load({commit}, params) {
        return new Promise((resolve, reject) => {
            commit(types.LOAD_PROJECTS_LOADING);
            http.get('projects/complete', {params: params}).then(({data}) => {
                commit(types.LOAD_PROJECTS_SUCCESS, data)
                resolve(data)
            }).catch(({response}) => {
                commit(types.LOAD_PROJECTS_ERROR)
                reject(response.data)
            })
        })
    }
};
